export const hrmCardStyles = {
    section: {
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    stat: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        padding: "12px",
    }
};

export const hrmGridStyles = {
    grid: {
        display: "grid",
        gap: "16px",
    }
};

export const hrmChipStyles = {
    base: {
        padding: "4px 8px",
        borderRadius: "16px",
        fontSize: "12px",
    }
};

export const createIconBadgeStyles = (color: string) => ({
    backgroundColor: `${color}1A`,
    color: color,
    padding: "8px",
    borderRadius: "8px",
});
